import React from 'react';

const DefaultFooter = () => (
  <React.Fragment />
);

export default DefaultFooter;
